module.exports = __webpack_public_path__ + "img/warning_.fe304396.svg";